
@if (tabs()) {
  <div class="tab-group" #tabGroup>
    @for (tab of tabs(); track tab.id) {
      @if (menuRoot() === tab) {
        @if (menuContent().length > 0) {
          <div class="menus-anchor">
            <div class="menus" data-testid="flat-tabs-menu">
              @for (menu of menuContent(); track menu.id) {
                <div class="menu">
                  @for (tab of menu.tabs; track tab.id) {
                    <button [attr.data-testid]="'flat-tabs-menu-tab-' + tab.name" (click)="selectTab(tab)" (mouseenter)="onTabHovered(menu, tab)" class="tab align-left" [title]="getTooltipForTab(tab)" [class.highlighted]="hoveredTabs().includes(tab)" [class.selected]="currentPath() === tab.path">
                      <!-- Quick and dirty for testing -->
                      @switch (tab.type) {
                        @case ('home') { <mat-icon>home</mat-icon> }
                        @case ('customer') { <mat-icon>factory_filled</mat-icon> }
                        @case ('order') { <mat-icon>note_alt_filled</mat-icon> }
                        @case ('article') {
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
                            <path d="M0 0H12L9 4.2V17L6 20L3 17V4.2L0 0ZM5 8H7V3.6L8 2H4L5 3.6V8ZM7 10H5V12H7V10ZM7 16V14H5V16L6 17L7 16Z" fill="white"/>
                          </svg>
                        }
                      }
                      @if (tab.path != 'home') {
                        {{ tab.name() || tab.fallbackName }}
                      }
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
      <button [attr.data-testid]="'flat-tabs-tab-' + tab.name" (click)="onTabClicked(tab)" class="tab" [title]="getTooltipForTab(tab)" [class.selected]="currentPath() === tab.path" [cdkContextMenuTriggerFor]="contextMenu">
        @if (tab.path === 'home') {
          <mat-icon>home</mat-icon>
        } @else {
          <!-- Quick and dirty for testing -->
          @switch (tab.type) {
            @case ('home') { <mat-icon>home</mat-icon> }
            @case ('customer') { <mat-icon>factory_filled</mat-icon> }
            @case ('order') { <mat-icon>note_alt_filled</mat-icon> }
            @case ('article') {
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
                <path d="M0 0H12L9 4.2V17L6 20L3 17V4.2L0 0ZM5 8H7V3.6L8 2H4L5 3.6V8ZM7 10H5V12H7V10ZM7 16V14H5V16L6 17L7 16Z" fill="white"/>
              </svg>
            }
          }
          {{ tab.name() || tab.fallbackName }}
          <!-- <button (click)="$event.stopPropagation(); close(tab)" class="invisible reveal">
            <ngt-button matIcon="close" scale="mini" shape="square" styling="tertiary" />
          </button> -->
        }
      </button>
      <ng-template #contextMenu>
        <div class="context-menu" cdkMenu>
          <button class="context-menu-item" (click)="close(tab)" cdkMenuItem [attr.data-testid]="'flat-tabs-context-close-' + tab.name">{{('windowtabs:close' | translate)()}}</button>
        </div>
      </ng-template>
      <!-- @if (!menuRoot() && !$last) {
        <div class="arrow-anchor">
          <div class="arrow">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
      } -->
    }
  </div>
}
